import React from "react";
import { ReactComponent as CloseIcon } from "../../../Assets/Icons/CloseIconSvg.svg";
import { ReactComponent as FileIcon } from "../../../Assets/Icons/fileIcon.svg";
import { getS3PublicUrl } from "../../../utils/s3";
import "../../common/common.scss";

const FilesPopup = ({ files, handleClose, title }) => {
    const handleDownload = async (url, fileName) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Error downloading file:", error);
            // Fallback: open in new tab if fetch fails
            window.open(url, "_blank");
        }
    };

    return (
        <div className="popup-container">
            <div
                className={`popup flex flex-col justify-evenly items-center sm:w-[550px] bg-white rounded-[10px] drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] relative pt-5 ${files.length > 4 ? "pb-8 h-[550px]" : "pb-8"
                    }`}
            >
                <div className="absolute top-[-18px] right-[-20px] z-[1001]">
                    <CloseIcon
                        className="cursor-pointer w-[32px] h-[32px] hover:scale-110 transition-transform active:scale-95"
                        onClick={handleClose}
                    />
                </div>
                <div className="h-[92%] w-full flex flex-col justify-start gap-4">
                    <div className="flex flex-col px-5 pt-3">
                        <span className="font-poppins font-[600] text-[18px] text-left text-[#303030]">
                            Assets for "{title}"
                        </span>
                        <span className="font-poppins font-[400] text-[14px] text-left text-[#767676]">
                            All uploaded files for this promotion
                        </span>
                    </div>

                    <div
                        className={`flex flex-col gap-3 w-full px-5 ${files.length > 4 ? "overflow-y-auto" : ""
                            }`}
                    >
                        {files?.map((file, index) => {
                            const fileUrl = typeof file === 'string' ? file : file.url;
                            const assetLabel = typeof file === 'string' ? 'Asset' : (file.category || "Asset");
                            const fileName = fileUrl.split("/").pop()?.split("?")[0] || `${title}_${assetLabel}_${index + 1}`;
                            const fullUrl = getS3PublicUrl(fileUrl);

                            return (
                                <div
                                    key={index}
                                    className="flex justify-between items-center w-full gap-4 rounded-[10px] bg-white shadow-[0_2px_8px_0px_rgba(0,0,0,0.08)] py-4 px-4 border border-[#F0F0F0]"
                                >
                                    <div className="flex items-center gap-3 overflow-hidden">
                                        <div className="bg-[#F4FCFF] p-2 rounded-lg flex-shrink-0">
                                            <FileIcon className="w-5 h-5 text-[#00ADEF]" />
                                        </div>
                                        <div className="flex flex-col overflow-hidden">
                                            <span className="font-poppins font-[700] text-[13px] text-[#00ADEF] uppercase tracking-wider">
                                                {assetLabel}
                                            </span>
                                            <span className="font-poppins font-[400] text-[12px] text-[#8C8C8C] truncate" title={fileName}>
                                                {fileName}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="flex gap-2">
                                        <a
                                            href={fullUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="px-4 py-1.5 bg-[#00ADEF] text-white rounded-md font-poppins text-[12px] font-[500] hover:bg-[#0095d1] transition-colors"
                                        >
                                            View
                                        </a>
                                        <button
                                            onClick={() => handleDownload(fullUrl, fileName)}
                                            className="px-4 py-1.5 border border-[#00ADEF] text-[#00ADEF] rounded-md font-poppins text-[12px] font-[500] hover:bg-[#F0FBFF] transition-colors"
                                        >
                                            Download
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilesPopup;
